import React, { useContext } from 'react'
import { Table, Col, Input, Button, Row, Card, Popover } from 'antd'
import SearchOutlined from '@ant-design/icons/lib/icons/SearchOutlined'
import MoreOutlined from '@ant-design/icons/lib/icons/MoreOutlined'

// Context
import { Context, useStore } from '../../../context'

const { Search } = Input

function UserSessionTable(props) {
  const [state] = useContext(Context)
  const { hasPermissions } = useStore(state)

  const getFilteredData = data => {
    props.handlerTextSearch(data)
  }

  const handlerCloseSession = row => {
    props.handlerCloseSession(row)
  }

  const columns = [
    {
      title: 'Nombre',
      dataIndex: '_name', // Field that is goint to be rendered
      key: '_name',
      render: text => <span>{text}</span>,
    },    
    {
      title: 'Email',
      dataIndex: '_email', // Field that is goint to be rendered
      key: '_nit',
      render: text => <span>{text}</span>,
    },
    {
      title: 'Teléfono',
      dataIndex: '_telefono', // Field that is goint to be rendered
      key: '_telefono',
      render: text => <span>{text}</span>,
    },    
    {
      title: 'Username',
      dataIndex: '_username', // Field that is goint to be rendered
      key: '_username',
      render: text => <span>{text}</span>,
    },
    {
      title: 'Fecha y hora de inicio',
      dataIndex: '_updated_at', // Field that is goint to be rendered
      key: '_updated_at',
      render: text => <span>{text}</span>,
    },
    {
      title: '',
      dataIndex: '_id', // Field that is goint to be rendered
      key: '_id',
      render: (row, data) => (
        <span>
          {
            <Popover
              placement="left"
              content={
                <div>
                  {hasPermissions([1]) && (
                    <>
                      <span className={'user-options-items'} onClick={() => handlerCloseSession(data)}>
                        Cerrar sesión
                      </span>                      
                    </>
                  )}                 
                </div>
              }
              trigger="click"
            >
              {(hasPermissions([7]) || hasPermissions([8])) && (
                <Button shape={'circle'} className={'enterprise-settings-button'}>
                  <MoreOutlined />
                </Button>
              )}
            </Popover>
          }
        </span>
      ),
    },
  ]

  return (
    <>
      <Row>
        <Col xs={18} sm={18} md={18} lg={18}>
          <Search
            className={'customSearch'}
            prefix={<SearchOutlined className={'tendero-table-search-icon'} />}
            placeholder="Presiona enter para buscar"
            style={{ width: '70%', height: '40px' }}
            size={'large'}
            onSearch={e => getFilteredData(e)}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={24} sm={24} md={24} lg={24}>
          <Card className={'card-border-radius margin-top-15'}>
            <Row>
              <Col xs={24} sm={24} md={24} lg={24}>
                <Table
                  loading={props.loading}
                  className={'CustomTableClass'}
                  dataSource={props.dataSource}
                  columns={columns}
                  pagination={false}
                  rowKey="_id"                  
                />
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </>
  )
}

export default UserSessionTable
